export default __webpack_public_path__ + "static/media/hb.51e43b48.png";